/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

export default function TrashIcon({
  width = 12,
  height = 15,
  color = '#3C5873',
}) {
  return (
    <svg width={width} height={height} viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.6464 6.66667C3.6464 6.29848 3.94488 6 4.31307 6C4.68126 6 4.97974 6.29848 4.97974 6.66667V10.6667C4.97974 11.0349 4.68126 11.3333 4.31307 11.3333C3.94488 11.3333 3.6464 11.0349 3.6464 10.6667V6.66667Z" fill={color} />
      <path d="M6.97974 6C6.61155 6 6.31307 6.29848 6.31307 6.66667V10.6667C6.31307 11.0349 6.61155 11.3333 6.97974 11.3333C7.34793 11.3333 7.6464 11.0349 7.6464 10.6667V6.66667C7.6464 6.29848 7.34793 6 6.97974 6Z" fill={color} />
      <path fillRule="evenodd" clipRule="evenodd" d="M3.33382 0C1.32883 0 -0.222457 1.75727 0.0262315 3.74678L1.17223 12.9147C1.29733 13.9156 2.14813 14.6667 3.15678 14.6667H8.13603C9.14467 14.6667 9.99548 13.9156 10.1206 12.9147L11.2666 3.74678C11.5153 1.75727 9.96398 0 7.95899 0H3.33382ZM1.44739 2.66667C1.72018 1.897 2.45423 1.33333 3.33382 1.33333H7.95899C8.83858 1.33333 9.57263 1.897 9.84542 2.66667H1.44739ZM1.40159 4L2.49526 12.7494C2.53697 13.083 2.82057 13.3333 3.15678 13.3333H8.13603C8.47224 13.3333 8.75584 13.083 8.79755 12.7494L9.89122 4H1.40159Z" fill={color} />
    </svg>
  );
}

TrashIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};
